import { Vector2 } from "three";

/**
 * 水平布局的对齐方式
 */
const HorizontalAlignment = {
  Upper: 9,
  Center: 10,
  Lower: 11,
};

/**
 * 垂直布局的对齐方式
 */
const VerticleAlignment = {
  Left: 12,
  Center: 13,
  Right: 14,
};

/**
 * 网格滚动视图的排列方式，水平优先或垂直优先
 */
const StartAxis = {
  Horizontal: 15,
  Verticle: 16,
};

/**
 * 布局基类
 */
class VLayoutBase {
  constructor() {
    /**
     * 代表滚动视图左右上下的边距
     */
    this.border = new Vector2(0, 0);
  }

  /**
   * 设置滚动视图左右上下的边距
   * @param {Vector2} v x值表示左右边距，y值表示上下边距
   */
  setBorder(v) {
    this.border = v;
  }
}

/**
 * 网格布局
 */
class VGridLayout extends VLayoutBase {
  constructor() {
    super();

    this.cellSize = new Vector2(0.1, 0.1);
    this.spacing = new Vector2(0, 0);
    this.startAxis = StartAxis.Horizontal;
    /**
     * 单行或单列的最大数量限制。如果startAxis为水平优先，则此值限制水平上最多有countLimit列元素，同理，如果startAxis为垂直优先，则此值限制垂直上最多有countLimit行元素
     */
    this.countLimit = 5;
  }

  /**
   * 设置网格布局的单元大小
   * @param {Vector2} v
   */
  setCellSize(v) {
    this.cellSize.copy(v);
  }

  /**
   * 设置网格布局的间隔大小
   * @param {Vector2} v
   */
  setSpacing(v) {
    this.spacing.copy(v);
  }

  /**
   * 设置水平优先或是垂直优先
   * @param {*} v
   */
  setStartAxis(v) {
    if (Object.values(StartAxis).includes(v)) this.startAxis = v;
  }

  /**
   * 设置单行或单列数量限制
   * @param {*} v
   */
  setCountLimit(v) {
    this.countLimit = Math.max(1, v);
  }
}

/**
 * 水平布局
 */
class VHorizontalLayout extends VLayoutBase {
  constructor() {
    super();

    this.spacing = 0;
    this.alignment = HorizontalAlignment.Upper;
  }

  /**
   * 设置水平布局的间隔
   * @param {Number} v
   */
  setSpacing(v) {
    this.spacing = v;
  }

  /**
   * 设置水平布局的对齐方式
   * @param {HorizontalAlignment} v
   */
  setAliment(v) {
    if (Object.values(HorizontalAlignment).includes(v)) this.alignment = v;
  }
}

/**
 * 垂直布局
 */
class VVerticleLayout extends VLayoutBase {
  constructor() {
    super();

    this.spacing = 0;
    this.alignment = VerticleAlignment.Left;
  }

  /**
   * 设置垂直布局的间隔
   * @param {Number} v
   */
  setSpacing(v) {
    this.spacing = v;
  }

  /**
   * 设置垂直布局的对齐方式
   * @param {VerticleAlignment} v
   */
  setAliment(v) {
    if (Object.values(VerticleAlignment).includes(v)) this.alignment = v;
  }
}

export {
  HorizontalAlignment,
  VerticleAlignment,
  StartAxis,
  VGridLayout,
  VHorizontalLayout,
  VVerticleLayout,
};
